/**
 * Table definition
 * */
let HashTable = function() {
  this.table = {};
}

/**
 * Add element
 * @param key  - Uniq key for element
 * @param value - Value for element
 * */
HashTable.prototype.addElement = function(key, value) {
  // console.log("HashTable.prototype.addElement-----key",key);
  // console.log("HashTable.prototype.addElement-----value",value);

  // console.log("this.table[key]",this.table[key]);
    
  if (this.table[key]){
    // console.log('Element dont added already exists');
  } else {
    this.table[key] = value;
  }

  // console.log("this.table",this.table)
}

/**
 * Update element
 * @param key - Uniq key for element
 * @param value - Value for element
 * */
HashTable.prototype.updateElement = function(key, value) {
  // console.log("HashTable.prototype.updateElement -----key",key);
  // console.log("HashTable.prototype.updateElement -----value",value);

  // console.log("this.table[key]",this.table[key]);
  
  if(this.table[key]){
    // console.log("se cuemple");
    
    this.table[key] = value;
  }else{
    // console.log('Element does not exist');
  }
}

/**
 * Get Element
 * @param key - Uniq key for element
 * */
HashTable.prototype.getElement = function(key) {
  // console.log("HashTable.prototype.getElement---key",key)
  return this.table[key];
  
}

/**
 * Verify if element exists
 * @param key - Uniq key for element
 * */
HashTable.prototype.exist = function(key) {
  // console.log("HashTable.prototype.exist---key",key)
  // console.log("this.table-->",this.table);
  
  if(this.table[key]){
    return true;
  }
  return false;
}

/**
 * Remove element
 * @param key - Uniq key for element
 * */
HashTable.prototype.remove = function(key) {
  delete this.table[key];
}

/**
 * Return the list of elements
 * */
HashTable.prototype.elements = function() {
  let table_hash = [];
  // console.log("this.table",this.table)
  for (const key in this.table){
    // console.log("this.table.hasOwnProperty(key)",this.table.hasOwnProperty(key));
    
    if(this.table.hasOwnProperty(key)){
      const element = this.table[key];
      table_hash.push(element);
    }
  }
  return table_hash;
}

/**
 * Exports
 * */
module.exports = HashTable;
